import {EffectCallback, useEffect} from 'react';

/**
 * Run's an effect on mount, and is cleaned up on unmount.
 * Equivalent to useEffect once.
 *
 * @param effect An effect to run on mount
 *
 */
export function useMountEffect(effect: EffectCallback) {
  // deliberately passing an empty array so that the effect is only run on mount and unmount
  // oxlint-disable-next-line exhaustive-deps
  return useEffect(effect, []);
}
